import { User } from 'src/app/shared/models/user.model';
import { Currency } from 'src/app/shared/models/currency.model';
import { TransferType } from './transfer-type.model';
import { DepositCryptoDto } from './deposit-crypto.dto.model';

export class DepositCrypto {
  adminUser: User;
  id: number;
  user: User;
  currency: Currency;
  wallet: string;
  amount: number;
  hash: string;
  confirmations: number;
  createdAt: string;
  receivedAt: string;
  originUser?: User;
  originWallet?: string;
  transferType: TransferType;
  network: string;

  constructor(input: DepositCryptoDto) {
    this.user = new User(input.user);
    this.adminUser = new User(input.admin_user);
    this.currency = new Currency(input.currency);
    this.id = input.id;
    this.wallet = input.wallet;
    this.amount = input.amount;
    this.hash = input.hash;
    this.confirmations = input.confirmations;
    this.createdAt = input.created_at;
    this.receivedAt = input.received_at;
    this.network = input.network;
    this.transferType = input.type_transfer;

    if (input.from_user || input.type_transfer === TransferType.Internal) {
      this.originWallet = input.wallet;
      this.originUser = new User(input.from_user);
    }
  }
}
